import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
//import { AuthenticationService } from './services/authentication/Authentication.service';
import { AlertService } from './services/alert/Alert.service';
//import { ServerhandlerService } from './services/serverHandler/serverhandler.service';
import { AlertComponent } from './components/Alert/Alert.component';
import { UseHttpImageSourcePipe } from './pipes/UseHttpImageSourcePipe.pipe';
import { InputDialogComponent } from './components/inputDialog/inputDialog.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
// import { ColorSliderComponent } from './components/colorSlider/colorSlider.component';
// import { ColorPickerComponent } from './components/colorPicker/colorPicker.component';
// import { ColorPaletteComponent } from './components/colorPalette/colorPalette.component';
import { MatExpansionModule } from '@angular/material/expansion';
// import { ColorPickerDialogComponent } from './components/colorPickerDialog/colorPickerDialog.component';
//import { ListValueItemComponent } from './components/listValueItem/listValueItem.component';
//import { ListValueSelectorComponent } from './components/listValueSelector/listValueSelector.component';
import { OverlayModule } from '@angular/cdk/overlay';
import { MatIconModule } from '@angular/material/icon';
//import { MultiChipListComponent } from './components/multiChipList/multiChipList.component';
// import { SingleUserSelectorComponent } from './components/singleUserSelector/singleUserSelector.component';
//import { ExtensionsCustomItemLabelComponent } from './components/extensionsCustomItemLabel/extensionsCustomItemLabel.component';
// import { SingleUserDisplayComponent } from './components/singleUserDisplay/singleUserDisplay.component';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { ToastNoAnimationModule } from 'ngx-toastr';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatSelectModule } from '@angular/material/select';
import { MatMenuModule } from '@angular/material/menu';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatChipsModule } from '@angular/material/chips';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatRadioModule } from '@angular/material/radio';
import { FileSizePipe } from './pipes/fileSize.pipe';
import { ChunkedFileUploadComponent } from './components/chunkedFileUpload/chunkedFileUpload.component';
// import { SingleUserSelectorItemComponent } from './components/SingleUserSelectorItem/SingleUserSelectorItem.component';
import { SingleGroupSelectorItemComponent } from './components/singleGroupSelectorItem/singleGroupSelectorItem.component';
// import { UserPreferencesComponent } from './components/userPreferences/userPreferences.component';
// import { SingleRoleSelectorComponent } from './components/SingleRoleSelector/SingleRoleSelector.component';
// import { SingleRoleSelectorItemComponent } from './components/SingleRoleSelectorItem/SingleRoleSelectorItem.component';
import { TimePipe } from './pipes/time.pipe';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { ResultTableComponent } from './components/resultTable/resultTable.component';
import { ResultTableRowComponent } from './components/ResultTableRow/ResultTableRow.component';
import { ResultTableCellComponent } from './components/ResultTableCell/ResultTableCell.component';
//import { DataPermissionComponent } from './components/dataPermission/dataPermission.component';
//import { DataPermissionService } from './services/dataPermission/dataPermission.service';
//import { GeoCoordinateComponent } from './components/geoCoordinate/geoCoordinate.component';

@NgModule({
  imports: [
    DragDropModule,
    CommonModule,
    MatCheckboxModule,
    MatRadioModule,
    MatSelectModule,
    MatMenuModule,
    MatInputModule,
    MatButtonModule,
    MatProgressBarModule,
    MatDatepickerModule,
    MatFormFieldModule,
    MatExpansionModule,
    FormsModule,
    ReactiveFormsModule,
    OverlayModule,
    MatSlideToggleModule,
    MatChipsModule,
    MatIconModule,
    MatAutocompleteModule,
    ToastNoAnimationModule.forRoot({
      timeOut: 20000,
      positionClass: 'toast-top-right',
      preventDuplicates: true,
    }), // ToastrModule added
  ],
  // declarations: [ AlertComponent, UseHttpImageSourcePipe, InputDialogComponent, ColorSliderComponent, ColorPickerComponent, ColorPaletteComponent, ColorPickerDialogComponent, ChunkedFileUploadComponent, SingleGroupSelectorItemComponent,
  //   ListValueSelectorComponent, ListValueItemComponent, MultiChipListComponent, SingleUserSelectorComponent, ExtensionsCustomItemLabelComponent, SingleUserDisplayComponent, SingleUserSelectorItemComponent,
  //   UserPreferencesComponent, SingleRoleSelectorComponent, SingleRoleSelectorItemComponent, DataPermissionComponent, GeoCoordinateComponent,
  //   FileSizePipe, TimePipe, ResultTableComponent, ResultTableRowComponent, ResultTableCellComponent],
  declarations: [ AlertComponent, UseHttpImageSourcePipe, InputDialogComponent, ChunkedFileUploadComponent, SingleGroupSelectorItemComponent,
    FileSizePipe, TimePipe, ResultTableComponent, ResultTableRowComponent, ResultTableCellComponent],
  // providers: [AuthenticationService, AlertService, ServerhandlerService, DataPermissionService],
  providers: [AlertService],
  // exports: [AlertComponent, UseHttpImageSourcePipe, InputDialogComponent, ChunkedFileUploadComponent, ColorPickerComponent, ColorPickerDialogComponent, ListValueSelectorComponent, MultiChipListComponent, SingleUserSelectorComponent, SingleGroupSelectorItemComponent, ExtensionsCustomItemLabelComponent, SingleUserDisplayComponent, FileSizePipe,
  //   UserPreferencesComponent, SingleRoleSelectorComponent,
  //   SingleUserSelectorItemComponent, TimePipe, ResultTableComponent, GeoCoordinateComponent
  // ]
  exports: [AlertComponent, UseHttpImageSourcePipe, InputDialogComponent, ChunkedFileUploadComponent, SingleGroupSelectorItemComponent, FileSizePipe,
    TimePipe, ResultTableComponent
  ]

})
export class SharedModule { }
